import { DateFormatter } from '@repo/toolkit/date'

import { AccomodationCategoryEnum } from '../../types/enums/product/accomodation-category.enum'
import { AcademicZoneEnum } from '../../types/enums/staff/academic-zone.enum'
import { JourneyFilters } from '../../types/models/product/journey'

export const transformJourneyFiltersToUrl = (filters?: JourneyFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.age) searchParams.append('age', filters.age.toString())
  if (filters.years && filters.years.length) searchParams.append('years', filters.years.join(','))

  if (filters.options && filters.options.length)
    searchParams.append('options', filters.options.join(','))

  if (filters.tripIds && filters.tripIds.length)
    searchParams.append('tripIds', filters.tripIds.join(','))

  if (filters.journeyPlaces && filters.journeyPlaces.length)
    searchParams.append('journeyPlaces', filters.journeyPlaces.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  if (filters.durationInDays && filters.durationInDays.length)
    searchParams.append('durationInDays', filters.durationInDays.join(','))

  if (filters.accomodationCategories && filters.accomodationCategories.length)
    searchParams.append('accomodationCategories', filters.accomodationCategories.join(','))

  if (filters.startDate) searchParams.append('startDate', filters.startDate)

  if (filters.endDate) searchParams.append('endDate', filters.endDate)

  if (filters.academicZone) searchParams.append('academicZone', filters.academicZone)

  if (filters.tripIds && filters.tripIds.length)
    searchParams.append('tripIds', filters.tripIds.join(','))

  if (filters.withoutRad) searchParams.append('withoutRad', filters.withoutRad.toString())

  return searchParams.toString()
}

export const transformUrlToJourneyFilters = (searchParams: URLSearchParams): JourneyFilters => {
  const filters: JourneyFilters = {}

  const age = searchParams.get('age')
  if (age) filters.age = Number(age)

  const years = searchParams.get('years')
  if (years && years.length) filters.years = years.split(',').map(Number)

  const options = searchParams.get('options')
  if (options && options.length) filters.options = options.split(',')

  const tripIds = searchParams.get('tripIds')
  if (tripIds && tripIds.length) filters.tripIds = tripIds.split(',').map(Number)

  const journeyPlaces = searchParams.get('journeyPlaces')
  if (journeyPlaces && journeyPlaces.length) filters.journeyPlaces = journeyPlaces.split(',')

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')

  const countries = searchParams.get('countries')
  if (countries && countries.length) filters.countries = countries.split(',')

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length) filters.formulas = formulas.split(',')

  const durationInDays = searchParams.get('durationInDays')
  if (durationInDays && durationInDays.length)
    filters.durationInDays = durationInDays.split(',').map(Number)

  const accomodationCategories = searchParams.get('accomodationCategories')
  if (accomodationCategories && accomodationCategories.length)
    filters.accomodationCategories = accomodationCategories.split(
      ','
    ) as AccomodationCategoryEnum[]

  const academicZone = searchParams.get('academicZone')
  if (academicZone) filters.academicZone = academicZone as AcademicZoneEnum

  const startDate = DateFormatter.checkDateFormat(searchParams.get('startDate'))
  if (startDate) filters.startDate = startDate

  const endDate = DateFormatter.checkDateFormat(searchParams.get('endDate'))
  if (endDate) filters.endDate = endDate

  if (searchParams.get('withoutRad'))
    filters.withoutRad = searchParams.get('withoutRad') === 'true'

  return filters
}
